<script setup>
const props = defineProps({
  timezones: {
    required: false,
    type: Array,
  },
})

const { t } = useI18n()
const { browserTimeZone, shouldConvertTimeZone } = useTimeZone()

const displayMessage = computed(() => {
  if (props.timezones?.length ===  1 && shouldConvertTimeZone)
    return t('All times {timezone}', { timezone: props.timezones[0] })

  else
    return t('All times relative to venue')
})
</script>

<template>
  <template v-if="shouldConvertTimeZone">
    <span>
      {{ t('All times {timezone}', { timezone: browserTimeZone.replace('_', ' ') }) }}
    </span>
  </template>
  <template v-else>
    {{ displayMessage }}
  </template>
</template>

<i18n>
{
  "en-us": {
    "All times {timezone}": "All times {timezone}",
    "All times relative to venue": "All times relative to venue"
  }
}
</i18n>

  <i18n locale="de" lang="json">
{
  "All times {timezone}": "Zeitzone: {timezone}",
  "All times relative to venue": "Lokale Studiozeit"
}
</i18n>

  <i18n locale="fr" lang="json">
{
  "All times {timezone}": "Toutes les heures {timezone}",
  "All times relative to venue": "Tous les horaires liés au lieu"
}
</i18n>

  <i18n locale="es" lang="json">
{
  "All times {timezone}": "Todos los horarios {timezone}",
  "All times relative to venue": "Todos los tiempos son relativos al local"
}
</i18n>
